var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutsideLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0: Base / Icon / 32px / chevron-right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-\\u21B3-Mobile-navigation-2023",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-menu-/-Pyha-/-Logged-in-menu",
    transform: "translate(-324.000000, -264.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0:-Base-/-Icon-/-32px-/-chevron-right",
    transform: "translate(324.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,24 C1.46666667,24 1,23.8 0.6,23.4 C0.2,23 0,22.5333333 0,22 L0,2 C0,1.46666667 0.2,1 0.6,0.6 C1,0.2 1.46666667,0 2,0 L11.3,0 L11.3,2 L2,2 L2,22 L22,22 L22,12.7 L24,12.7 L24,22 C24,22.5333333 23.8,23 23.4,23.4 C23,23.8 22.5333333,24 22,24 L2,24 Z M8.73333333,16.7 L7.33333333,15.2666667 L20.6,2 L13.3,2 L13.3,0 L24,0 L24,10.7 L22,10.7 L22,3.43333333 L8.73333333,16.7 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutsideLinkIcon);
export default __webpack_public_path__ + "static/media/outside-link-icon.fc09ced52250644036148a1021b3fa6c.svg";
export { ForwardRef as ReactComponent };